<template>
  <div id="pc-contextmenu" class="pc-contextmenu" v-show="visible" @mousedown.stop @click="contextmenuClickHandler">
    <div class="group" v-if="isWorkbenchSidebarCatalogNotebook">
      <div class="item" @click="addNotebookCatalogHandler">添加目录</div>
      <div class="item" @click="addNotebookNoteHandler">添加笔记</div>
      <div class="divide"></div>
      <div class="item" @click="renameHandler">重命名</div>
      <div class="divide"></div>
      <div class="item" v-if="pasteAvailable" @click="pasteHandler">粘贴</div>
      <div class="item disabled" v-else>粘贴</div>
    </div>
    <div class="group" v-if="isWorkbenchSidebarCatalogNotebookNote">
      <div class="item" @click="cutHandler">剪切</div>
      <div class="divide"></div>
      <div class="item" @click="renameHandler">重命名</div>
      <div class="item" @click="removeHandler">删除</div>
      <div class="divide"></div>
      <div class="item" @click="upOrderHandler">上移</div>
      <div class="item" @click="downOrderHandler">下移</div>
    </div>
    <div class="group" v-if="isWorkbenchSidebarCatalogNotebookCatalog">
      <div class="item" @click="addNotebookCatalogHandler">添加目录</div>
      <div class="item" @click="addNotebookNoteHandler">添加笔记</div>
      <div class="divide"></div>
      <div class="item" @click="cutHandler">剪切</div>
      <div class="item" v-if="pasteAvailable" @click="pasteHandler">粘贴</div>
      <div class="item disabled" v-else>粘贴</div>
      <div class="divide"></div>
      <div class="item" @click="renameHandler">重命名</div>
      <div class="item" @click="removeHandler">删除</div>
      <div class="divide"></div>
      <div class="item" @click="upOrderHandler">上移</div>
      <div class="item" @click="downOrderHandler">下移</div>
    </div>
    <div class="group" v-if="isWorkbenchSidebarCatalogMore">
      <div class="item">全部折叠</div>
      <div class="item">定位到当前笔记</div>
    </div>
    <div class="group" v-if="isWorkbenchSidebarOutlineNote">
      <div class="item" @click="renameHandler">重命名</div>
    </div>
    <div class="group" v-if="isWorkbenchSidebarOpenedMore">
      <div class="item">排序：打开时间</div>
      <div class="item">排序：名称</div>
      <div class="divide"></div>
      <div class="item">关闭全部</div>
      <div class="item">关闭全部非置顶</div>
      <div class="item">关闭全部置顶</div>
      <div class="item">关闭当前外其他</div>
      <div class="divide"></div>
      <div class="item">取消全部置顶</div>
    </div>
    <div class="group" v-if="isWorkbenchSidebarOpenedItem">
      <div class="item">置顶</div>
      <div class="item">取消置顶</div>
    </div>
    <div class="group" v-if="isSidebarTools">
      <div class="item" @click="settingHandler">设置</div>
      <div class="divide"></div>
      <div class="item" @click="logoutHandler">退出登录</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import _ from 'lodash'
import { operateError } from '@/common/errors'

export default {
  computed: {
    ...mapGetters('contextmenu', {
      visible: 'visible',
      isWorkbenchSidebarCatalogNotebook: 'isWorkbenchSidebarCatalogNotebook',
      isWorkbenchSidebarCatalogNotebookNote: 'isWorkbenchSidebarCatalogNotebookNote',
      isWorkbenchSidebarCatalogNotebookCatalog: 'isWorkbenchSidebarCatalogNotebookCatalog',
      isWorkbenchSidebarOutlineNote: 'isWorkbenchSidebarOutlineNote',
      isWorkbenchSidebarOutlineMore: 'isWorkbenchSidebarOutlineMore',
      isWorkbenchSidebarCatalogMore: 'isWorkbenchSidebarCatalogMore',
      isWorkbenchSidebarOpenedMore: 'isWorkbenchSidebarOpenedMore',
      isWorkbenchSidebarOpenedItem: 'isWorkbenchSidebarOpenedItem',
      isSidebarTools: 'isSidebarTools',
      data: 'data',
      cutData: 'cutData'
    }),
    ...mapGetters('workbench/current', {
      isNotebook: 'isNotebook',
      note: 'note',
      getNotebookCatalog: 'getNotebookCatalog',
      getNotebookNote: 'getNotebookNote',
      catalogPaths: 'catalogPaths',
      catalogParents: 'catalogParents'
    }),
    pasteAvailable () {
      if (!this.cutData.id) {
        return false
      }
      if (this.cutData.notebookId !== this.$route.params.notebookId) {
        return false
      }
      if (this.data.type === 'NOTEBOOK') {
        if (this.cutData.parentId === '') {
          return false
        }
      }
      if (this.cutData.parentId === this.data.id) {
        return false
      }
      if (this.cutData.id === this.data.id) {
        return false
      }
      if (this.cutData.type === 'NOTEBOOK_CATALOG' && this.data.type === 'NOTEBOOK_CATALOG') {
        if (_.includes(this.catalogParents(this.data.id), this.cutData.id)) {
          return false
        }
      }
      return true
    }
  },
  methods: {
    ...mapMutations('dialog', {
      setAddNotebookCatalogDialogValue: 'SET_ADD_NOTEBOOK_CATALOG',
      setAddNotebookNoteDialogValue: 'SET_ADD_NOTEBOOK_NOTE',
      setRenameDialogValue: 'SET_RENAME'
    }),
    ...mapMutations('contextmenu', {
      setContextmenuVisible: 'SET_VISIBLE',
      setCutData: 'SET_CUT_DATA'
    }),
    ...mapActions('workbench/current', {
      removeNotebookCatalog: 'removeNotebookCatalog',
      removeNotebookNote: 'removeNotebookNote',
      upCatalogOrder: 'upCatalogOrder',
      downCatalogOrder: 'downCatalogOrder',
      upNoteOrder: 'upNoteOrder',
      downNoteOrder: 'downNoteOrder',
      changeCatalogParentCatalog: 'changeCatalogParentCatalog',
      changeNoteCatalog: 'changeNoteCatalog'
    }),
    ...mapActions('auth', {
      logout: 'logout'
    }),
    contextmenuClickHandler () {
      this.setContextmenuVisible(false)
    },
    addNotebookCatalogHandler () {
      if (this.data.type === 'NOTEBOOK') {
        this.setAddNotebookCatalogDialogValue({
          visible: true,
          data: {
            parentCatalogId: ''
          }
        })
      } else if (this.data.type === 'NOTEBOOK_CATALOG') {
        this.setAddNotebookCatalogDialogValue({
          visible: true,
          data: {
            parentCatalogId: this.data.id
          }
        })
      }
    },
    addNotebookNoteHandler () {
      if (this.data.type === 'NOTEBOOK') {
        this.setAddNotebookNoteDialogValue({
          visible: true,
          data: {
            catalogId: ''
          }
        })
      } else if (this.data.type === 'NOTEBOOK_CATALOG') {
        this.setAddNotebookNoteDialogValue({
          visible: true,
          data: {
            catalogId: this.data.id
          }
        })
      }
    },
    renameHandler () {
      if (this.data.type === 'NOTEBOOK') {
        this.setRenameDialogValue({
          visible: true,
          data: {
            type: 'NOTEBOOK'
          }
        })
      } else if (this.data.type === 'NOTEBOOK_CATALOG') {
        this.setRenameDialogValue({
          visible: true,
          data: {
            type: 'NOTEBOOK_CATALOG',
            id: this.data.id
          }
        })
      } else if (this.data.type === 'NOTEBOOK_NOTE') {
        this.setRenameDialogValue({
          visible: true,
          data: {
            type: 'NOTEBOOK_NOTE',
            id: this.data.id
          }
        })
      } else if (this.data.type === 'NOTE') {
        if (this.isNotebook) {
          this.setRenameDialogValue({
            visible: true,
            data: {
              type: 'NOTEBOOK_NOTE',
              id: this.note.id
            }
          })
        } else {
          this.setRenameDialogValue({
            visible: true,
            data: {
              type: 'NOTE'
            }
          })
        }
      }
    },
    removeHandler () {
      if (this.data.type === 'NOTEBOOK_CATALOG') {
        const catalog = this.getNotebookCatalog(this.data.id)
        const paths = this.catalogPaths(catalog.parentCatalogId)
        paths.push(catalog.name)
        const name = paths.join(' / ')
        this.$confirm(`此操作将删除 ( ${name} ) 及其所有子目录和文件, 是否继续?`, '删除目录提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const reloadNotebook = await this.removeNotebookCatalog(this.data.id)
          if (reloadNotebook) {
            this.$router.push({
              name: 'workbenchNotebook',
              params: {
                notebookId: this.$route.params.notebookId
              }
            })
          }
        }).catch(() => {
        })
      } else if (this.data.type === 'NOTEBOOK_NOTE') {
        const note = this.getNotebookNote(this.data.id)
        const paths = this.catalogPaths(note.catalogId)
        paths.push(note.name)
        const name = paths.join(' / ')
        this.$confirm(`此操作将删除 ( ${name} ) , 是否继续?`, '删除笔记提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const reloadNotebook = await this.removeNotebookNote(this.data.id)
          if (reloadNotebook) {
            this.$router.push({
              name: 'workbenchNotebook',
              params: {
                notebookId: this.$route.params.notebookId
              }
            })
          }
        }).catch(() => {
        })
      }
    },
    async upOrderHandler () {
      if (this.data.type === 'NOTEBOOK_CATALOG') {
        const catalogId = this.data.id
        try {
          await this.upCatalogOrder(catalogId)
        } catch (err) {
          console.dir(err)
        }
      } else if (this.data.type === 'NOTEBOOK_NOTE') {
        const noteId = this.data.id
        try {
          await this.upNoteOrder(noteId)
        } catch (err) {
          console.dir(err)
        }
      }
    },
    async downOrderHandler () {
      if (this.data.type === 'NOTEBOOK_CATALOG') {
        const catalogId = this.data.id
        try {
          await this.downCatalogOrder(catalogId)
        } catch (err) {
          console.dir(err)
        }
      } else if (this.data.type === 'NOTEBOOK_NOTE') {
        const noteId = this.data.id
        try {
          await this.downNoteOrder(noteId)
        } catch (err) {
          console.dir(err)
        }
      }
    },
    async cutHandler () {
      if (this.data.type === 'NOTEBOOK_CATALOG') {
        const catalogId = this.data.id
        const cutData = {
          id: catalogId,
          notebookId: this.$route.params.notebookId,
          type: 'NOTEBOOK_CATALOG',
          parentId: this.data.parentId
        }
        this.setCutData(cutData)
      } else if (this.data.type === 'NOTEBOOK_NOTE') {
        const noteId = this.data.id
        const cutData = {
          id: noteId,
          notebookId: this.$route.params.notebookId,
          type: 'NOTEBOOK_NOTE',
          parentId: this.data.parentId
        }
        this.setCutData(cutData)
      }
    },
    async pasteHandler () {
      if (this.pasteAvailable) {
        if (this.cutData.type === 'NOTEBOOK_CATALOG' && this.data.type === 'NOTEBOOK') {
          this.changeCatalogParentCatalog({ catalogId: this.cutData.id, parentCatalogId: '' })
        } else if (this.cutData.type === 'NOTEBOOK_CATALOG' && this.data.type === 'NOTEBOOK_CATALOG') {
          this.changeCatalogParentCatalog({ catalogId: this.cutData.id, parentCatalogId: this.data.id })
        } else if (this.cutData.type === 'NOTEBOOK_NOTE' && this.data.type === 'NOTEBOOK') {
          this.changeNoteCatalog({ noteId: this.cutData.id, catalogId: '' })
        } else if (this.cutData.type === 'NOTEBOOK_NOTE' && this.data.type === 'NOTEBOOK_CATALOG') {
          this.changeNoteCatalog({ noteId: this.cutData.id, catalogId: this.data.id })
        }
      }
      this.setCutData({})
    },
    async logoutHandler () {
      this.$confirm('确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await this.logout()
          this.$router.replace({
            name: 'login'
          })
        } catch (e) {
          operateError(e, '退出登录')
        }
      }).catch(() => {
      })
    },
    goIssuesHander () {
      window.open('https://github.com/lowkeyfish/peacock-issues')
    },
    settingHandler () {
      this.$router.push({
        name: 'settings'
      })
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';
.pc-contextmenu {
  position: absolute;
  background: white;
  border: 1px solid $border-color-structure;
  box-shadow: 0 0 3px $border-color-structure;
  z-index: 2001;
  top: 50px;
  min-width: 200px;
  padding: .5rem 0;

  .item {
    padding: .5rem 2rem;
    cursor: default;

    &:not(.disabled):hover {
      background: $color-hover;
      cursor: pointer;
    }
  }

  .divide {
    margin: .5rem 1rem;
    border-top: 1px solid $border-color-structure;
  }

  .disabled {
    color: $color-b4;
  }
}
</style>
